import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonComponent } from './button/button.component';
import { TileAddComponent } from './tile-add/tile-add.component';
import { IconButtonComponent } from './icon-button/icon-button.component';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { TranslocoModule } from '@jsverse/transloco';
import { SharedDirectiveModule } from '@railmybox/shared/directive';
import { MenuModule } from 'primeng/menu';
import { DropdownButtonComponent } from './dropdown-button/dropdown-button.component';
import { SpinnerModule } from '../spinner';

@NgModule({
  declarations: [ButtonComponent, TileAddComponent, IconButtonComponent, DropdownButtonComponent],
  imports: [CommonModule, FlexLayoutModule, TranslocoModule, SharedDirectiveModule, MenuModule, SpinnerModule],
  exports: [ButtonComponent, TileAddComponent, IconButtonComponent, DropdownButtonComponent],
})
export class ButtonModule {}
